var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"loadingContainer",style:({
    background: _vm.backgroundColor ? 'rgb(219, 147, 28)' : 'rgba(0,0,0, 0.4)',
  }),on:{"mousewheel":_vm.mousewheel}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('div',{}),_c('div',{}),_c('div',{})])
}]

export { render, staticRenderFns }